import React, { useState, useEffect } from "react";
import { View, Text, Platform, StyleSheet, Switch } from "react-native";

import AppTheme from "../../AppTheme";

export default function IntegrationToggle({
  isEnabled,
  isAutoTracked,
  onPress = () => {},
}) {
  const [isSyncing, setIsSyncing] = useState(isEnabled);
  useEffect(() => {
    setIsSyncing(isEnabled);
  }, [isEnabled]);

  const toggle = (is_syncing) => {
    setIsSyncing(is_syncing);
    onPress(is_syncing);
  };

  return (
    <View>
      <View style={styles.toggleContainer}>
        <Switch
          value={isSyncing}
          onValueChange={(status) => toggle(status)}
          thumbColor="#FFF"
          trackColor={{
            true: AppTheme.DEFAULT_COLOR,
            false: "#f3f2f1",
          }}
        />
      </View>

      <Text style={[styles.caption, { textAlign: "center", marginTop: 3 }]}>
        {isEnabled
          ? isAutoTracked
            ? "Autotracking"
            : "Suggesting"
          : "Not Syncing"}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  caption: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  toggleContainer: {
    display: "flex",
    alignItems: "center",
    minWidth: 60,
  },
});
